import { React, useState } from "react";
// import { Link } from "react-router-dom";
import "./DeliveryPrograms.css";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import DLF from "./DLF";

// const style = {
//   position: 'absolute',
//   top: '50%',
//   left: '50%',
//   transform: 'translate(-50%, -50%)',
//   width: 400,
//   bgcolor: 'background.paper',
//   border: '2px solid #000',
//   boxShadow: 24,
//   p: 4,
// };


function DeliveryPrograms() {
  const [isFlipped, setIsFlipped] = useState(null); 

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true)
    console.log(open, "openKiValue");
  };
  const handleClose = () => setOpen(false);

  return (
    <>
      <div className="deliveryPrograms-main-container">


        <div className="SSA-container">
          <div className="SSA-wrap">
            {/* <h2>Security Specialization Academy</h2> */}
            <p className="intro-text">
              Delivery Programs are for all employees to upskill and enhance on
              specific skills related to sales origination, building trusted
              client relationships and managing and growing complex SI projects.
            </p>
            <div className="SSA-row">

              <div
                className={isFlipped == "5" ? "flip-card" : "flip-card-unhover"}
              >
                <div
                  className={
                    isFlipped == "5"
                      ? "flip-card-inner"
                      : "flip-card-inner-unhover"
                  }
                >
                  <div className="SSA-box-front">
                    {/* <Link to={'/securityTrainingCalendar'} className="calendar-link"> */}
                    <img
                      src="./images/Delivery/Agile.png"
                      alt="SSA-img"
                      className="SSA-img"
                    />
                    <div className="SSA-box-content">
                      <h3>Agile</h3>
                      <p>
                        Explore this space to know about various learning
                        options that Learning and Knowledge
                        &nbsp;
                        <a
                          className="learn-more"
                          onClick={() =>
                            isFlipped == null
                              ? setIsFlipped("5")
                              : setIsFlipped(null)
                          }
                        >
                          Learn more
                        </a>
                      </p>
                      <a
                        className="card-link"
                        href="https://atci.lkm.delivery.accenture.com/Agile/"
                        target="_blank"
                      >
                        Agile
                      </a>
                    </div>
                    {/* </Link> */}
                  </div>
                  <div
                    className="SSA-box-back"
                    onMouseLeave={() =>
                      isFlipped == "5" ? setIsFlipped(null) : setIsFlipped("5")
                    }
                  >
                    <h3 className="backHeading">Agile</h3>
                    <p>
                      Explore this space to know about various learning options
                      that Learning and Knowledge Management team provides in
                      building Agile competency.
                    </p>
                  </div>
                </div>
              </div>


              <div
                className={isFlipped == "6" ? "flip-card" : "flip-card-unhover"}
              >
                <div
                  className={
                    isFlipped == "6"
                      ? "flip-card-inner"
                      : "flip-card-inner-unhover"
                  }
                >
                  <div className="SSA-box-front">
                    {/* <a href="https://ts.accenture.com/sites/IS-Learning/Security/Pages/default.aspx" target='_blank'> */}
                    <img
                      src="./images/Delivery/Devops.png"
                      alt="SSA-img"
                      className="SSA-img"
                    />
                    <div className="SSA-box-content">
                      <h3>DevOps</h3>
                      <p>
                        DevOpsLearning Opportunities will be extended to all
                        Accenture resources and makes Complex
                        &nbsp;
                        <a
                          className="learn-more"
                          onClick={() =>
                            isFlipped == null
                              ? setIsFlipped("6")
                              : setIsFlipped(null)
                          }
                        >
                          Learn more
                        </a>
                      </p>
                      <a
                        className="card-link"
                        href="https://atci.lkm.delivery.accenture.com/DevOps/"
                        target="_blank"
                      >
                        Devops
                      </a>
                    </div>
                    {/* </a> */}
                  </div>
                  <div
                    className="SSA-box-back"
                    onMouseLeave={() =>
                      isFlipped == "6" ? setIsFlipped(null) : setIsFlipped("6")
                    }
                  >
                    <h3 className="backHeading">DevOps</h3>
                    <p>
                      DevOpsLearning Opportunities will be extended to all
                      Accenture resources and makes Complex DevOps technologies
                      to be easily understandable by them through extensive
                      hands-on practice.
                    </p>
                  </div>
                </div>
              </div>


              <div
                className={isFlipped == "7" ? "flip-card" : "flip-card-unhover"}
              >
                <div
                  className={
                    isFlipped == "7"
                      ? "flip-card-inner"
                      : "flip-card-inner-unhover"
                  }
                >
                  <div className="SSA-box-front">
                    <img
                      src="./images/Delivery/TechCore.png"
                      alt="SSA-img"
                      className="SSA-img"
                    />
                    <div className="SSA-box-content">
                      <h3>TechCore</h3>
                      <p>
                        Learning Labs focuses on experiential learning with
                        cloud labs by creating a virtual,&nbsp;
                        <a
                          className="learn-more"
                          onClick={() =>
                            isFlipped == null
                              ? setIsFlipped("7")
                              : setIsFlipped(null)
                          }
                        >
                          Learn more
                        </a>
                      </p>
                      <a
                        className="card-link"
                        href="https://atci.lkm.delivery.accenture.com/TechCore/"
                        target="_blank"
                      >
                        TechCore
                      </a>
                    </div>
                  </div>
                  
                  <div
                    className="SSA-box-back"
                    onMouseLeave={() =>
                      isFlipped == "7" ? setIsFlipped(null) : setIsFlipped("7")
                    }
                  >
                    <h3 className="backHeading">TechCore</h3>
                    <p>
                      Technology Core Learning journey provides a clear learning
                      path for employees at each career level across delivery
                      and professional skills.
                    </p>
                  </div>
                </div>
              </div>


              <div
                className={isFlipped == "9" ? "flip-card" : "flip-card-unhover"}
              >
                <div
                  className={
                    isFlipped == "9"
                      ? "flip-card-inner"
                      : "flip-card-inner-unhover"
                  }
                >
                  <div className="SSA-box-front">
                    {/* <a href="https://atci.lkm-securitylearnings.accenture.com/Cyberbit/home" target='_blank'> */}
                    <img
                      src="./images/Delivery/Delivery-Sales-Academy.png"
                      alt="SSA-img"
                      className="SSA-img"
                    />
                    <div className="SSA-box-cont">
                      <h3>SRE</h3>
                      <p>
                        Site Reliability Engineering (SRE), focuses on delivering ultra-scalable and highly reliable software systems.&nbsp;
                        <a
                          className="learn-more"
                          onClick={() =>
                            isFlipped == null
                              ? setIsFlipped("9")
                              : setIsFlipped(null)
                          }
                        >
                          Learn more
                        </a>
                      </p>
                      <a
                        className="card-link"
                        href="https://atci.lkm.delivery.accenture.com/SRE/"
                        target="_blank"
                        
                      >
                        SRE Portal (accenture.com)
                      </a>
                    </div>
                    {/* </a> */}
                  </div>
                  <div
                    className="SSA-box-back"
                    onMouseLeave={() =>
                      isFlipped == "9" ? setIsFlipped(null) : setIsFlipped("2")
                    }
                  >
                    <h3 className="backHeading">Delivery Sales Academy</h3>
                    <p>
                      Site Reliability Engineering (SRE), focuses on delivering ultra-scalable and highly reliable software systems.SRE team uses an engineering-based approach to manage systems, solve problems, and automate operations tasks.
                    </p>
                  </div>
                </div>
              </div>



               <div
                className={isFlipped == "1" ? "flip-card" : "flip-card-unhover"}
              >
                <div
                  className={
                    isFlipped == "1"
                      ? "flip-card-inner"
                      : "flip-card-inner-unhover"
                  }
                >
                  <div className="SSA-box-front">
                    {/* <Link to={'/securitySchools'} className="calendar-link"> */}
                    <img
                      src="./images/Delivery/DFA.png"
                      alt="SSA-img"
                      className="SSA-img"
                    />
                    <div className="SSA-box-cont">
                      <h3>Delivery Foundation Academy</h3>
                      <p>
                      Delivery Foundation Academy (DFA) features learnings designed to impart the basic&nbsp;
                        <a
                          className="learn-more"
                          onClick={() =>
                            isFlipped == null
                              ? setIsFlipped("1")
                              : setIsFlipped(null)
                          }
                        >
                          Learn more
                        </a>
                      </p>
                      <a
                        className="card-link"
                        href="https://atci.lkm.delivery.accenture.com/DLF/DFA"
                        target="_blank"
                      >
                        Delivery Foundation Academy
                      </a>
                    </div>
                    {/* </Link> */}
                  </div>
                  <div
                    className="SSA-box-back"
                    onMouseLeave={() =>
                      isFlipped == "1" ? setIsFlipped(null) : setIsFlipped("1")
                    }
                  >
                    <h3 className="backHeading">
                    Delivery Foundation Academy
                    </h3>
                    <p>Delivery Foundation Academy (DFA) features learnings designed to impart the basic
                        Read Lessdelivery skills required at a specific career level. The learnings focuses on process, methodologies, programming fundamentals, tools and techniques required for a seamless delivery.
                    </p>
                  </div>
                </div>
              </div>



              <div
                className={isFlipped == "8" ? "flip-card" : "flip-card-unhover"}
              >
                <div
                  className={
                    isFlipped == "8"
                      ? "flip-card-inner"
                      : "flip-card-inner-unhover"
                  }
                >
                  <div className="SSA-box-front">
                    <img
                      src="./images/Delivery/System Integration 1.jpg"
                      alt="SSA-img"
                      className="SSA-img"
                    />
                    <div className="SSA-box-content">
                      <h3>System Integration</h3>
                      <p>
                        Transform SI Delivery through Accenture’s refreshed strategies, applied innovation, and global expertise&nbsp;
                        <a
                          className="learn-more"
                          onClick={() =>
                            isFlipped == null
                              ? setIsFlipped("8")
                              : setIsFlipped(null)
                          }
                        >
                          Learn more
                        </a>
                      </p>
                      <a
                        className="card-link"
                        href="https://atci.lkm.delivery.accenture.com/SystemIntegration/"
                        target="_blank"
                      >
                        System Integration
                      </a>
                    </div>
                  </div>
                  <div
                    className="SSA-box-back"
                    onMouseLeave={() =>
                      isFlipped == "8" ? setIsFlipped(null) : setIsFlipped("8")
                    }
                  >
                    <h3 className="backHeading"> System Integration</h3>
                    <p>
                      Transform SI Delivery through Accenture’s refreshed strategies, applied innovation, and global expertise&nbsp;
                    </p>
                    {/* <p className="knowMore-link"
                      onClick={handleOpen}
                    ><button>Know More</button></p> */}
                    <Modal
                      open={open}
                      onClose={handleClose}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                    >
                      <Box className='delivery-modal'>
                        <img
                          src="images/Delivery/DeliveryCloseIcon.png"
                          alt="close-icon"
                          onClick={handleClose}
                          className="close-icon"
                        />
                        <p className="DLP-inner-head"><span>Delivery Leadership Program</span></p>
                        <div className="modalInner-Row">
                          <div
                            className={isFlipped == "1" ? "flip-card" : "flip-card-unhover"}
                          >
                            <div
                              className={
                                isFlipped == "1"
                                  ? "flip-card-inner"
                                  : "flip-card-inner-unhover"
                              }
                            >
                              <div className="SSA-box-front">
                                {/* <a href="https://atci.lkm-securitylearnings.accenture.com/Cyberbit/home" target='_blank'> */}
                                <img
                                  src="./images/Delivery/Delivery-Lead-Practitioner.png"
                                  alt="SSA-img"
                                  className="SSA-img"
                                />
                                <div className="SSA-box-cont">
                                  <h3>Delivery Lead Practitioner School</h3>
                                  <p>
                                    Delivery Lead Practitioner School is a deep skilled
                                    course, mandatory for CDL <br />
                                    <a
                                      className="learn-more"
                                      onClick={() =>
                                        isFlipped == null
                                          ? setIsFlipped("1")
                                          : setIsFlipped(null)
                                      }
                                    >
                                      Learn more
                                    </a>
                                  </p>
                                  <a
                                    className="card-link"
                                    href="https://atci.lkm.delivery.accenture.com/leadershipprograms/DLPS"
                                    target="_blank"
                                  >
                                    Delivery Lead Practitioner School
                                  </a>
                                </div>
                                {/* </a> */}
                              </div>
                              <div
                                className="SSA-box-back"
                                onMouseLeave={() =>
                                  isFlipped == "1" ? setIsFlipped(null) : setIsFlipped("1")
                                }
                              >
                                <h3 className="backHeading">Delivery Lead Practitioner School</h3>
                                <p>
                                  Delivery Lead Practitioner School is a deep skilled
                                  course, mandatory for CDL certifications. Mandatory for
                                  SI/AO Delivery lead certification. Provides deep insight
                                  into the delivery skills required for the Delivery leads
                                  to carry out their responsibilities.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            className={isFlipped == "2" ? "flip-card" : "flip-card-unhover"}
                          >
                            <div
                              className={
                                isFlipped == "2"
                                  ? "flip-card-inner"
                                  : "flip-card-inner-unhover"
                              }
                            >
                              <div className="SSA-box-front">
                                {/* <a href="https://atci.lkm-securitylearnings.accenture.com/Cyberbit/home" target='_blank'> */}
                                <img
                                  src="./images/Delivery/Delivery-Sales-Academy.png"
                                  alt="SSA-img"
                                  className="SSA-img"
                                />
                                <div className="SSA-box-cont">
                                  <h3>Delivery Sales Academy</h3>
                                  <p>
                                    Delivery Sales Academy is a high-end leadership program
                                    that is designed to help you{" "}
                                    <a
                                      className="learn-more"
                                      onClick={() =>
                                        isFlipped == null
                                          ? setIsFlipped("2")
                                          : setIsFlipped(null)
                                      }
                                    >
                                      Learn more
                                    </a>
                                  </p>
                                  <a
                                    className="card-link"
                                    href="https://atci.lkm.delivery.accenture.com/leadershipprograms/DSA"
                                    target="_blank"
                                  >
                                    Delivery Sales Academy
                                  </a>
                                </div>
                                {/* </a> */}
                              </div>
                              <div
                                className="SSA-box-back"
                                onMouseLeave={() =>
                                  isFlipped == "2" ? setIsFlipped(null) : setIsFlipped("2")
                                }
                              >
                                <h3 className="backHeading">Delivery Sales Academy</h3>
                                <p>
                                  Delivery Sales Academy is a high-end leadership program
                                  that is designed to help you originate sales opportunities
                                  by building upon client relationships and effective
                                  positioning of Accenture offerings.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                      </Box>
                    </Modal>

                  </div>

                </div>
              </div>
              



              <div
                className={isFlipped == "3" ? "flip-card" : "flip-card-unhover"}
              >
                <div
                  className={
                    isFlipped == "3"
                      ? "flip-card-inner"
                      : "flip-card-inner-unhover"
                  }
                >
                  <div className="SSA-box-front">
                    {/* <Link to={'/securitySchools'} className="calendar-link"> */}
                    <img
                      // src="./images/Delivery/Project-Management.png"
                      src="./images/Delivery/Frame 3.png"
                      alt="SSA-img"
                      className="SSA-img"
                    />
                    <div className="SSA-box-cont">
                      <h3>Project Management</h3>
                      <p>
                        Project Management ensures the successful achievement of goals by leveraging methodologies like Waterfall or Agile, managing scope, schedule, and budget&nbsp;
                        <a
                          className="learn-more"
                          onClick={() =>
                            isFlipped == null
                              ? setIsFlipped("3")
                              : setIsFlipped(null)
                          }
                        >
                          Learn more
                        </a>
                      </p>
                      <a
                        className="card-link"
                        href="https://atci.lkm.delivery.accenture.com/ProjectManagement/"
                        target="_blank"
                      >
                        Project Management
                      </a>
                    </div>
                    {/* </Link> */}
                  </div>
                  <div
                    className="SSA-box-back"
                    onMouseLeave={() =>
                      isFlipped == "3" ? setIsFlipped(null) : setIsFlipped("3")
                    }
                  >
                    <h3 className="backHeading">Project Management</h3>
                    <p>
                      {/* Project Management Foundation School (PMFS) is intended
                      for the tenured Team Leads. It is a blended certification
                      program with experience sharing by experts and self-study
                      of key project management topics. */}

                      Project Management ensures the successful achievement of goals by leveraging methodologies like Waterfall or Agile, managing scope, schedule, and budget&nbsp;
                    </p>
                  </div>
                </div>
              </div>
              <div
                className={isFlipped == "4" ? "flip-card" : "flip-card-unhover"}
              >
                <div
                  className={
                    isFlipped == "4"
                      ? "flip-card-inner"
                      : "flip-card-inner-unhover"
                  }
                >
                  <div className="SSA-box-front">
                    {/* <a href="https://in.accenture.com/technologyecosystemventures/partners/" target='_blank'> */}
                    <img
                      // src="./images/Delivery/ITIL.png"
                      src="./images/Delivery/Frame 4.png"
                      alt="SSA-img"
                      className="SSA-img"
                    />
                    <div className="SSA-box-content">
                      <h3>Application Management Services</h3>
                      <p>
                        Accenture's Application Management Services streamline operations, drive agility, reduce costs, and foster innovation in enterprise application lifecycle&nbsp;
                        <a
                          className="learn-more"
                          onClick={() =>
                            isFlipped == null
                              ? setIsFlipped("4")
                              : setIsFlipped(null)
                          }
                        >
                          Learn more
                        </a>
                      </p>
                      <a
                        className="card-link"
                        href="https://atci.lkm.delivery.accenture.com/ApplicationManagementServices"
                        target="_blank"
                      >
                        Application Management Services
                      </a>
                    </div>
                    {/* </a> */}
                  </div>
                  <div
                    className="SSA-box-back"
                    onMouseLeave={() =>
                      isFlipped == "4" ? setIsFlipped(null) : setIsFlipped("4")
                    }
                  >
                    <h3 className="backHeading">Application Management Services</h3>
                    <p>
                      {/* ITIL is a key skillset required in the Service Management
                      space. ITIL provides a framework for managing all aspects
                      of IT service delivery from the development and deployment
                      of new services to improvement and replacement of existing
                      ones. */}
                      Accenture's Application Management Services streamline operations, drive agility, reduce costs, and foster innovation in enterprise application lifecycle&nbsp;
                    </p>
                  </div>
                </div>
              </div>




              <div
                className={isFlipped == "2" ? "flip-card" : "flip-card-unhover"}
              >
                <div
                  className={
                    isFlipped == "2"
                      ? "flip-card-inner"
                      : "flip-card-inner-unhover"
                  }
                >
                  <div className="SSA-box-front">
                    {/* <Link to={'/securitySchools'} className="calendar-link"> */}
                    <img
                      src="./images/Delivery/Frame 2.png"
                      alt="SSA-img"
                      className="SSA-img"
                    />
                    <div className="SSA-box-cont">
                      <h3>Leadership Program</h3>
                      <p>
                      Accenture equips leaders with delivery skills to align with diverse models, ensuring client satisfaction and consistent outcomes&nbsp;
                        <a
                          className="learn-more"
                          onClick={() =>
                            isFlipped == null
                              ? setIsFlipped("2")
                              : setIsFlipped(null)
                          }
                        >
                          Learn more
                        </a>
                      </p>
                      <a
                        className="card-link"
                        href="https://atci.lkm.delivery.accenture.com/leadershipprograms/home"
                        target="_blank"
                      >
                        Leadership Program
                      </a>
                    </div>
                    {/* </Link> */}
                  </div>
                  <div
                    className="SSA-box-back"
                    onMouseLeave={() =>
                      isFlipped == "2" ? setIsFlipped(null) : setIsFlipped("2")
                    }
                  >
                    <h3 className="backHeading">
                    Leadership Program
                    </h3>
                    <p>
                    Through Delivery Leadership Programs we support Executive
                      level Leaders develop their delivery skills and meet the
                      client expectations supporting the core of Accenture's
                      Technology business.
                    </p>
                  </div>
                </div>
              </div>

              {/* <div
                className={isFlipped == "3" ? "flip-card" : "flip-card-unhover"}
              >
                <div
                  className={
                    isFlipped == "3"
                      ? "flip-card-inner"
                      : "flip-card-inner-unhover"
                  }
                >
                  <div className="SSA-box-front"> */}
                    {/* <Link to={'/securitySchools'} className="calendar-link"> */}
                    {/* <img
                      src="./images/Delivery/DAA.png"
                      alt="SSA-img"
                      className="SSA-img"
                    />
                    <div className="SSA-box-cont">
                      <h3>Delivery Adept Academy for Security</h3>
                      <p>
                      Delivery Adept Academy (DAA) for Security is designed for a career level with necessary&nbsp;
                        <a
                          className="learn-more"
                          onClick={() =>
                            isFlipped == null
                              ? setIsFlipped("3")
                              : setIsFlipped(null)
                          }
                        >
                          Learn more
                        </a>
                      </p>
                      <a
                        className="card-link"
                        href="https://atci.lkm-securitylearnings.accenture.com/DeliveryAdeptAcademy/"
                        target="_blank"
                      >
                        Delivery Adept Academy for Security
                      </a>
                    </div> */}
                    {/* </Link> */}
                  {/* </div>
                  <div
                    className="SSA-box-back"
                    onMouseLeave={() =>
                      isFlipped == "3" ? setIsFlipped(null) : setIsFlipped("3")
                    }
                  >
                    <h3 className="backHeading">
                      Delivery Adept Academy for Security
                    </h3>
                    <p>
                    Delivery Adept Academy (DAA) for Security is designed for a career level with necessary
                    Read Lesssecurity specialization to attain focused security delivery skills across security workforce.
                    </p>
                  </div>
                </div>
              </div> */}

              
              
              


            </div>

          </div>
          {/* <div className="SSA-wrap">
                        <div className="SSA-row">
                            
                        </div>
                    </div> */}

        </div>
      </div>
    </>
  );
}

export default DeliveryPrograms;
